<template>
  <div>
    <headerSection></headerSection>

    <!-- Main Container -->
    <div class="partner-page">
      <!-- Hero Section -->
      <div class="hero-section">
        <!-- Floating Balls -->
        <div class="floating-ball ball-1"></div>
        <div class="floating-ball ball-2"></div>
        <div class="floating-ball ball-3"></div>

        <div class="container">
          <div class="hero-content">
            <!-- Icon with bounce animation -->
            <div class="hero-icon-wrapper">
              <span class="hero-icon">🤝</span>
            </div>

            <!-- Title with glow -->
            <h1 class="title-glow">{{ $t('link_partner') }}</h1>

            <!-- Banner Image -->
            <div class="banner-wrapper">
              <img src="https://firebasestorage.googleapis.com/v0/b/connextcc.firebasestorage.app/o/images%2F-N5Zi0KwC5SYe4y7Pzwk.png?alt=media&token=c5377a1a-d147-4a7d-b80c-fe8fa8e38267" class="banner-img" alt="Partner Banner">
            </div>
          </div>
        </div>
      </div>

      <!-- Content Section -->
      <div class="container content-section">
        <!-- Referral Link Card -->
        <div class="referral-card glass-card">
          <div class="referral-input-group">
            <input
              id="copyTarget3"
              type="text"
              readonly
              class="referral-input"
              :value="partnerReferralUrl"
            >
            <button
              id="copyButton3"
              class="copy-btn btn-primary"
              v-clipboard:copy="partnerReferralUrl"
              v-clipboard:success="clipboardSuccessHandler"
            >
              <i class="fa fa-copy fa-sm mr-1"></i>{{ $t('copy') }}
            </button>
          </div>
          <p class="referral-hint">{{ $t('deposit_title3') }}</p>
        </div>

        <!-- Partner Stats Title -->
        <div class="section-title">
          <span class="title-text">{{ $t('partner_title') }}</span>
        </div>

        <!-- Stats Cards Grid -->
        <div class="partner-stats">
          <!-- Friends Count -->
          <div class="stat-card glass-card">
            <div class="stat-icon">👥</div>
            <div class="stat-label">{{ $t('partner_title2') }}</div>
            <div class="stat-value">{{ (friends) ? friends.length : 0 }}</div>
            <img
              src="../assets/images/analysis.png"
              class="analysis-icon"
              @click="showlevel(1)"
            >
          </div>

          <!-- Total Income Level 1 -->
          <div class="stat-card glass-card">
            <div class="stat-icon">💰</div>
            <div class="stat-label">{{ $t('partner_title4') }}</div>
            <div class="stat-value">{{ (partner && partner.total1) ? numberWithCommas(partner.total1) : '0.00' }}</div>
          </div>

          <!-- Total Income -->
          <div class="stat-card glass-card stat-card-full">
            <div class="stat-icon">💎</div>
            <div class="stat-label">{{ $t('partner_title6') }}</div>
            <div class="stat-value">{{ (partner && partner.total) ? numberWithCommas(partner.total) : '0.00' }}</div>
          </div>
        </div>

        <!-- Claim Button -->
        <div class="claim-button-wrapper">
          <button
            @click="movePartnerToWallet()"
            class="claim-btn btn-primary"
            :class="{ 'disabled': !(partner && partner.total > 0) }"
            :disabled="!(partner && partner.total > 0)"
          >
            <span class="claim-btn-text">{{ $t('partner_title7') }}</span>
          </button>
        </div>

        <!-- Partner Details -->
        <div class="partner-details glass-card" v-html="nl2br(detail)"></div>
      </div>
    </div>

    <!-- Detail Modal -->
    <div
      class="modal-overlay"
      :class="{ 'show': showdetail }"
      @click.self="closeDetail()"
    >
      <div class="modal-container">
        <div class="modal-content-wrapper glass-card">
          <!-- Close Button -->
          <button type="button" class="close-btn" @click="closeDetail()">
            <i class="fas fa-times"></i>
          </button>

          <!-- Modal Header -->
          <div class="modal-header">
            <h2 class="modal-title">{{ titleDetail }}</h2>
          </div>

          <!-- Modal Body -->
          <div class="modal-body">
            <p class="modal-subtitle">{{ $t('data_summary_yesterday') }}</p>

            <div class="table-container">
              <table class="data-table">
                <thead>
                  <tr>
                    <th>{{ $t('table_code') }}</th>
                    <th>{{ $t('table_date') }}</th>
                    <th>{{ $t('table_deposit') }}</th>
                    <th>{{ $t('table_withdraw') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in history" :key="index">
                    <td>{{ item.friend }}</td>
                    <td>{{ item.createdateShow }}</td>
                    <td class="text-right">{{ numberWithCommas(item.deposit) }}</td>
                    <td class="text-right">{{ numberWithCommas(item.withdraw) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Contact Support -->
            <div class="contact-support">
              <label class="contact-label">{{ $t('contact_problem') }}&nbsp;</label>
              <a
                :href="adminContactLineLink"
                class="contact-link"
                target="_blank"
                rel="noopener"
              >
                <u>{{ $t('contact_customer_service') }}</u>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footerSection></footerSection>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import router from './../router'
import moment from 'moment-timezone'
const axios = require('axios').default

const normalizeDomain = (value) => {
  const rawValue = (value || '').toString().trim().toLowerCase()
  if (!rawValue) return ''

  return rawValue
    .replace(/^https?:\/\//, '')
    .replace(/^\/\//, '')
    .split('/')[0]
    .split('?')[0]
    .split('#')[0]
    .replace(/:\d+$/, '')
}
export default {
  name: 'Partner',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue')
  },
  created () {
	  const user = localStorage.getItem('userData')
	  if (user) {
		  const _user = JSON.parse(user)
		  this.$store.dispatch('user/setUser', _user).catch(err => { console.error(err) })
	  } else {
      firebase.auth().signOut()
      localStorage.removeItem('userData')
      router.replace('/login')
	  }
  },
  data: function () {
    return {
      friends:[],
      partner: [],
      showdetail: false,
      titleDetail: '',
      history:[],
      detail:'',
      disabled: false
    }
  },
  mounted () {
    this.scrollToTop()
    this.getPartner()
  },
  computed: {
    user () {
      return this.$store.state.user.user
    },
    partnerReferralHost () {
      const configuredHost = normalizeDomain(this.$store.getters['settings/partnerReferralHost'])
      if (configuredHost) return configuredHost

      const activeDomains = this.$store.getters['settings/activeDomains'] || []
      const firstActiveHost = activeDomains.length ? normalizeDomain(activeDomains[0].host) : ''
      return firstActiveHost || normalizeDomain(window.location.hostname) || 'connextcc.com'
    },
    partnerReferralUrl () {
      const code = this.user && this.user.code ? this.user.code : ''
      return `https://${this.partnerReferralHost}/register?ref=${code}`
    },
    adminContactLineLink () {
      return this.$store.getters['settings/adminContactLineLink'] || this.$store.getters['settings/linkLine']
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    movePartnerToWallet () {
      if (this.partner.total && this.partner.key && !this.disabled) {
        this.disabled = true;
        this.$store.commit('user/SET_LOADING', true)
        this.$store.dispatch('user/moveCreditToWallet').finally((res) => {
          setTimeout(async () => {
            axios.get(`https://api.connextcc.cc/qpartner/partner/${this.partner.key}`)
            setTimeout(() => {
              this.getPartner()
              this.$store.commit('user/SET_LOADING', false)
            }, 2000)
          }, 2000)
        })
        setTimeout(() => {
          this.disabled = false;
        }, 2000);
      }
    },
    clipboardSuccessHandler () {
      this.$swal({ icon: 'success', title: 'Copy', text: this.$t('copy_success') })
    },
    checkStyle () {
      if (this.partner && this.partner.total > 0) {
        return 'background: linear-gradient(180deg,#fbc844,#f88012);height: 43px;min-width:120px;padding-left: 24px;padding-right: 24px;padding-top: 0.8em;'
      } else {
        return 'background: linear-gradient(180deg,#cccccc,#cccccc);height: 43px;min-width:120px;padding-left: 24px;padding-right: 24px;padding-top: 0.8em;'
      }
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/login')
      }
    },
    numberWithCommas (x) {
	  if (!x) x = 0
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    async getPartner () {
      this.detail = (await firebase.database().ref(`/partner/detail`).once('value')).val();
      const user = this.getUserId()
      if (user) {
        firebase.firestore().collection('partner').where('date', '==', moment().tz('Asia/Bangkok').format('YYYY-MM-DD')).where('userkey', '==', user.key).where('status', '==', false).get().then((snapshot) => {
          if (!snapshot.size) this.partner = []
          snapshot.forEach((doc) => {
            const data = doc.data()
            data.key = doc.id
            this.partner = data
          })
        })
        firebase.firestore().collection('friends').where('userkey','==',user.key).get().then((result)=>{
          result.forEach((doc)=>{
            const data = doc.data()
            data.key = doc.id
            this.friends.push(data)
          });
        });
      }
    },
    nl2br (str, is_xhtml) {
		if (typeof str === 'undefined' || str === null) {
			return '';
		}
		var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
		return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
	},
    async showlevel(level){
      const history = [];
      const deposit = [];
      const withdraw = [];
      if(level === 1){
        this.titleDetail = 'แนะนำเพื่อน';
        await firebase.firestore().collection('daily_deposit').where('createdate', '==', moment().tz('Asia/Bangkok').add(-1,'days').format('YYYY-MM-DD')).where('level1', '==', this.user.code).get().then((snapshot) => {
          snapshot.forEach((doc)=>{
            deposit[doc.data().code] = doc.data().total;
          });
        });
        await firebase.firestore().collection('daily_withdraw').where('createdate', '==', moment().tz('Asia/Bangkok').add(-1,'days').format('YYYY-MM-DD')).where('level1', '==', this.user.code).get().then((snapshot) => {
          snapshot.forEach((doc)=>{
            withdraw[doc.data().code] = doc.data().total;
          });
        });
        if(this.friends){
          for(const x in this.friends){
            if(deposit[this.friends[x].friend]){
              this.friends[x].deposit = deposit[this.friends[x].friend];
            }else{
              this.friends[x].deposit = 0;
            }
            if(withdraw[this.friends[x].friend]){
              this.friends[x].withdraw = withdraw[this.friends[x].friend];
            }else{
              this.friends[x].withdraw = 0;
            }
            this.friends[x].createdateShow = moment().add(-1,'days').format('DD MMM,YY')
            history.push(this.friends[x]);
          }
        }
      }else{
        this.titleDetail = 'เพื่อนแนะนำเพื่อน';
        await firebase.firestore().collection('daily_deposit').where('createdate', '==', moment().tz('Asia/Bangkok').add(-1,'days').format('YYYY-MM-DD')).where('level2', '==', this.user.code).get().then((snapshot) => {
          snapshot.forEach((doc)=>{
            deposit[doc.data().code] = doc.data().total;
          });
        });
        await firebase.firestore().collection('daily_withdraw').where('createdate', '==', moment().tz('Asia/Bangkok').add(-1,'days').format('YYYY-MM-DD')).where('level2', '==', this.user.code).get().then((snapshot) => {
          snapshot.forEach((doc)=>{
            withdraw[doc.data().code] = doc.data().total;
          });
        });
        if(this.user.level2){
          for(const x in this.user.level2){
            if(deposit[this.user.level2[x].code]){
              this.user.level2[x].deposit = deposit[this.user.level2[x].code];
            }else{
              this.user.level2[x].deposit = 0;
            }
            if(withdraw[this.user.level2[x].code]){
              this.user.level2[x].withdraw = withdraw[this.user.level2[x].code];
            }else{
              this.user.level2[x].withdraw = 0;
            }
            this.user.level2[x].createdateShow = moment().add(-1,'days').format('DD MMM,YY')
            history.push(this.user.level2[x]);
          }
        }
      }
      this.history = history;
      this.showdetail = true;
    },
    closeDetail(){
      this.showdetail = false;
    }
  }
}
</script>

<style scoped>
/* Page Background */
.partner-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #2b2727 0%, #1b1b1b 50%, #2b2727 100%);
  padding-bottom: 100px;
}

/* Hero Section */
.hero-section {
  position: relative;
  padding: 80px 0 30px;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(247, 178, 66, 0.1) 0%, transparent 100%);
}

.hero-content {
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
  padding: 0 20px;
}

.hero-icon-wrapper {
  display: inline-block;
  margin-bottom: 20px;
  animation: bounce 2s ease-in-out infinite;
}

.hero-icon {
  font-size: 64px;
  display: block;
  filter: drop-shadow(0 4px 15px rgba(247, 178, 66, 0.4));
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.title-glow {
  font-size: 36px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 25px;
  text-shadow:
    0 0 20px rgba(247, 178, 66, 0.5),
    0 0 40px rgba(247, 178, 66, 0.3),
    0 2px 4px rgba(0, 0, 0, 0.5);
}

.banner-wrapper {
  margin-top: 20px;
}

.banner-img {
  width: 100%;
  max-width: 500px;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

/* Floating Balls */
.floating-ball {
  position: absolute;
  border-radius: 50%;
  opacity: 0.15;
  pointer-events: none;
  z-index: 1;
}

.floating-ball.ball-1 {
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, #f7b242, #ce840c);
  top: -50px;
  left: -100px;
  animation: float1 6s ease-in-out infinite;
}

.floating-ball.ball-2 {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #ce840c, #f7b242);
  top: 50%;
  right: -75px;
  animation: float2 8s ease-in-out infinite;
}

.floating-ball.ball-3 {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #2b2727, #f7b242);
  bottom: 20%;
  left: 10%;
  animation: float3 7s ease-in-out infinite;
}

@keyframes float1 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(30px, 20px) rotate(180deg); }
}

@keyframes float2 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(-20px, 30px) rotate(-180deg); }
}

@keyframes float3 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(20px, -20px) rotate(180deg); }
}

/* Content Section */
.content-section {
  padding: 30px 20px;
  max-width: 900px;
  margin: 0 auto;
}

/* Glass Card Effect */
.glass-card {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(247, 178, 66, 0.2);
  border-radius: 12px;
  padding: 20px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.3),
    0 0 20px rgba(247, 178, 66, 0.1);
  transition: all 0.3s ease;
}

.glass-card:hover {
  border-color: rgba(247, 178, 66, 0.3);
  box-shadow:
    0 12px 40px rgba(0, 0, 0, 0.4),
    0 0 30px rgba(247, 178, 66, 0.15);
}

/* Referral Card */
.referral-card {
  margin-bottom: 30px;
}

.referral-input-group {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}

.referral-input {
  flex: 1;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(247, 178, 66, 0.3);
  border-radius: 8px;
  padding: 12px 15px;
  color: #fff;
  font-size: 14px;
  font-family: 'Kanit', sans-serif;
}

.referral-input:focus {
  outline: none;
  border-color: rgba(247, 178, 66, 0.5);
  box-shadow: 0 0 10px rgba(247, 178, 66, 0.2);
}

.copy-btn {
  white-space: nowrap;
}

.referral-hint {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
  text-align: center;
  font-family: 'Kanit', sans-serif;
}

/* Section Title */
.section-title {
  text-align: center;
  margin-bottom: 25px;
}

.title-text {
  font-size: 24px;
  font-weight: 600;
  color: #f7b242;
  font-family: 'Kanit', sans-serif;
  text-shadow: 0 0 15px rgba(247, 178, 66, 0.3);
}

/* Partner Stats Grid */
.partner-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  text-align: center;
  padding: 25px 20px;
  position: relative;
}

.stat-card-full {
  grid-column: 1 / -1;
}

.stat-icon {
  font-size: 40px;
  margin-bottom: 12px;
  filter: drop-shadow(0 2px 8px rgba(247, 178, 66, 0.3));
}

.stat-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 10px;
  font-family: 'Kanit', sans-serif;
}

.stat-value {
  font-size: 28px;
  font-weight: 700;
  color: #f7b242;
  text-shadow: 0 0 20px rgba(247, 178, 66, 0.5);
  font-family: 'Kanit', sans-serif;
}

.analysis-icon {
  width: 30px;
  height: 30px;
  margin-top: 12px;
  cursor: pointer;
  opacity: 0.7;
  transition: all 0.3s ease;
}

.analysis-icon:hover {
  opacity: 1;
  transform: scale(1.1);
}

/* Buttons */
.btn-primary {
  background: linear-gradient(135deg, #f7b242, #ce840c);
  border: none;
  border-radius: 8px;
  padding: 12px 30px;
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  font-family: 'Kanit', sans-serif;
  box-shadow:
    0 4px 15px rgba(247, 178, 66, 0.3),
    0 2px 5px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  cursor: pointer;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow:
    0 6px 20px rgba(247, 178, 66, 0.4),
    0 3px 8px rgba(0, 0, 0, 0.3);
  filter: brightness(1.1);
}

.btn-primary:active {
  transform: translateY(0);
}

.btn-primary.disabled,
.btn-primary:disabled {
  background: linear-gradient(135deg, #666, #444);
  cursor: not-allowed;
  box-shadow: none;
  opacity: 0.6;
}

.btn-primary.disabled:hover,
.btn-primary:disabled:hover {
  transform: none;
  filter: none;
}

/* Claim Button */
.claim-button-wrapper {
  text-align: center;
  margin-bottom: 30px;
}

.claim-btn {
  min-width: 200px;
}

.claim-btn-text {
  font-size: 14px;
  font-family: 'Kanit', sans-serif;
}

/* Partner Details */
.partner-details {
  text-align: center;
  font-size: 16px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.8);
  font-family: 'Kanit', sans-serif;
}

/* Modal Overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(5px);
  z-index: 9999;
  display: none;
  align-items: center;
  justify-content: center;
  padding: 20px;
  overflow-y: auto;
}

.modal-overlay.show {
  display: flex;
}

.modal-container {
  width: 100%;
  max-width: 800px;
  margin: auto;
}

.modal-content-wrapper {
  position: relative;
  padding: 30px;
  max-height: 90vh;
  overflow-y: auto;
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  background: rgba(247, 178, 66, 0.2);
  border: 1px solid rgba(247, 178, 66, 0.3);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f7b242;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;
}

.close-btn:hover {
  background: rgba(247, 178, 66, 0.3);
  transform: rotate(90deg);
}

.modal-header {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(247, 178, 66, 0.2);
}

.modal-title {
  font-size: 28px;
  font-weight: 700;
  color: #f7b242;
  margin: 0;
  font-family: 'Kanit', sans-serif;
  text-shadow: 0 0 15px rgba(247, 178, 66, 0.3);
}

.modal-body {
  padding: 20px 0;
}

.modal-subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 20px;
  text-align: center;
  font-family: 'Kanit', sans-serif;
}

/* Data Table */
.table-container {
  overflow-x: auto;
  overflow-y: auto;
  max-height: 500px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-family: 'Kanit', sans-serif;
}

.data-table thead {
  position: sticky;
  top: 0;
  z-index: 10;
}

.data-table th {
  background: linear-gradient(135deg, #f7b242, #ce840c);
  color: #fff;
  padding: 12px 15px;
  text-align: center;
  font-weight: 600;
  font-size: 16px;
}

.data-table td {
  padding: 12px 15px;
  text-align: center;
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  border-bottom: 1px solid rgba(247, 178, 66, 0.1);
}

.data-table td.text-right {
  text-align: right;
}

.data-table tbody tr:nth-child(odd) {
  background: rgba(247, 178, 66, 0.05);
}

.data-table tbody tr:nth-child(even) {
  background: rgba(0, 0, 0, 0.2);
}

.data-table tbody tr:hover {
  background: rgba(247, 178, 66, 0.15);
  transition: background 0.3s ease;
}

/* Contact Support */
.contact-support {
  text-align: center;
  padding: 15px;
  background: rgba(247, 178, 66, 0.05);
  border-radius: 8px;
  font-family: 'Kanit', sans-serif;
}

.contact-label {
  color: rgba(255, 255, 255, 0.8);
  font-size: 15px;
  margin: 0;
}

.contact-link {
  color: #f7b242;
  font-size: 15px;
  text-decoration: none;
  transition: all 0.3s ease;
}

.contact-link:hover {
  color: #ce840c;
  text-shadow: 0 0 10px rgba(247, 178, 66, 0.5);
}

/* Responsive Design */
@media screen and (max-width: 768px) {
  .hero-section {
    padding: 75px 0 25px;
  }

  .title-glow {
    font-size: 28px;
  }

  .hero-icon {
    font-size: 48px;
  }

  .floating-ball.ball-1 {
    width: 150px;
    height: 150px;
  }

  .floating-ball.ball-2 {
    width: 100px;
    height: 100px;
  }

  .floating-ball.ball-3 {
    width: 80px;
    height: 80px;
  }

  .partner-stats {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .stat-card-full {
    grid-column: 1;
  }

  .referral-input-group {
    flex-direction: column;
  }

  .modal-content-wrapper {
    padding: 20px;
  }

  .modal-title {
    font-size: 24px;
  }

  .data-table th,
  .data-table td {
    padding: 10px 8px;
    font-size: 13px;
  }
}

@media screen and (max-width: 480px) {
  .hero-section {
    padding: 70px 0 20px;
  }

  .title-glow {
    font-size: 24px;
  }

  .hero-icon {
    font-size: 40px;
  }

  .content-section {
    padding: 20px 15px;
  }

  .glass-card {
    padding: 15px;
  }

  .referral-input {
    font-size: 12px;
    padding: 10px 12px;
  }

  .btn-primary {
    padding: 10px 20px;
    font-size: 14px;
  }

  .stat-value {
    font-size: 24px;
  }

  .stat-icon {
    font-size: 32px;
  }

  .modal-content-wrapper {
    padding: 15px;
  }

  .data-table th,
  .data-table td {
    padding: 8px 5px;
    font-size: 12px;
  }
}
</style>
